'use strict'
module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-sanitize/index.js
// module id = 165
// module chunks = 94053359063892 107818501498521